import type { IDockviewPanelProps } from 'dockview';
import { kebabCase } from 'lodash-es';
import { useCallback } from 'react';
import { SingleMonitoringBlotter } from '../../../../containers/Monitoring/Blotters/SingleMonitoringBlotter';
import type { EntityName } from '../../../../containers/Monitoring/Blotters/types';
import { entityDisplayNames } from '../../../../containers/Monitoring/Blotters/types';
import type { EntityOverrideMonitoringPanelConfig, MonitoringBlotterPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';

type MonitoringPanelConfig = MonitoringBlotterPanelConfig | EntityOverrideMonitoringPanelConfig;

export function MonitoringBlotterPanel({
  api,
  params,
  entityOverride,
}: IDockviewPanelProps<MonitoringPanelConfig> & { entityOverride?: EntityName }) {
  const panelId = api.id;
  const panelLabel = api.title ?? 'Blotters';
  const customTitle = params.customTitle;
  const entity = 'entity' in params ? params.entity : undefined;

  const handleEntityChange = useCallback(
    (entity: EntityName | undefined) => {
      if (entity) {
        api.updateParameters({ entity });
        if (!customTitle) {
          api.setTitle(entityDisplayNames[entity].name);
        }
      }
    },
    [api, customTitle]
  );

  return (
    <Panel panelApi={api} data-testid={`${kebabCase(panelId)}-panel`}>
      <SingleMonitoringBlotter
        allowEntityChange={!entityOverride}
        entity={entityOverride ?? entity ?? 'Order'}
        panelLabel={panelLabel}
        panelId={panelId}
        onEntityChange={handleEntityChange}
      />
    </Panel>
  );
}
